var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text-muted mb-4",domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._t("button-add")],2)}
var staticRenderFns = []

export { render, staticRenderFns }